import { ProviderMapResults } from "@app/projects/results/common/mapping";
import ProjectionProvider from "@app/projects/results/projection-provider/projectionProvider";
import { ServicingProvider } from "@app/projects/results/servicing-provider";
import ProjectionProviderByEnum from "@app/projects/servicing-provider/projectionProviderByEnum";

export type MapPopupServicingProvider = ServicingProvider & Pick<ProjectionProvider, "reasonDescription">;

export const buildServicingProviderFromProviderMapResults = (provider: ProviderMapResults): MapPopupServicingProvider => {
  return {
    address: provider.address,
    address2: provider.address2,
    city: provider.city,
    contractType: null,
    countyFIPS: null,
    countySSA: null,
    credentials: provider.credentials,
    deactivatedNPI: false,
    displayName: provider.displayName,
    employmentStatus: null,
    entityType: provider.entityType,
    externLocationId: null,
    externProviderId: null,
    externRowId: null,
    externSpecialtyCode: null,
    externZip: null,
    firstName: provider.firstName,
    gender: null,
    geoInfoDisplay: null,
    invalidNPI: false,
    lastName: provider.lastName,
    latitude: provider.latitude,
    longitude: provider.longitude,
    medGroupAffiliation: null,
    medicareCCN: null,
    medicareCertifiedBeds: null,
    medicareOptOut: false,
    middleName: provider.middleName,
    missingNPI: false,
    name: provider.displayName,
    npi: provider.npi,
    oigExcluded: false,
    oigWaiver: false,
    organizationName: provider.organizationName,
    organizationNPI: provider.organizationNPI,
    planningRegion: null,
    precluded: false,
    prefix: provider.prefix,
    processed: false,
    providerId: provider.providerId,
    reasonDescription: provider.reasonDescription,
    servesPercent: provider.servesPercent,
    specialty: null,
    specialtyCode: provider.specialtyCode,
    specialtyName: null,
    state: provider.state,
    suffix: provider.suffix,
    taxonomyCode: null,
    tin: null,
    underContract: null,
    zip: provider.zip
  };
};

export const ProjectionProviderByEnumToDisplay = (projection: ProjectionProviderByEnum): string => {
  switch (projection) {
    case ProjectionProviderByEnum.NPI:
      return "NPI";
    case ProjectionProviderByEnum.TIN:
      return "TIN";
    case ProjectionProviderByEnum.ContractEntity:
      return "Contract Entity";
    case ProjectionProviderByEnum.Name:
      return "Name";
  }
};
